<template>
    <SocialAuthBtn
        img="https://image.flaticon.com/icons/svg/34/34227.svg"
        :label="$t('shared.loginModule.socialAuthBtns.continueWithLinkedIn')"
        color="#0077b5"
        class="linkedin-btn"
        @click="lLogIn"
        :tiny="tiny"
    />
</template>

<script>
import SocialAuthBtn from './SocialAuthBtn';
import LinkedInFlow from '~/utils/socialAuth/LinkedInFlow';

export default {
    name: 'LinkedInLoginBtn',
    components: { SocialAuthBtn },
    data: () => ({}),
    props: {
        redirectPath: String,
        tiny: Boolean,
    },
    methods: {
        setLoading(value) {
            this.$emit('input', value);
        },
        async lLogIn() {
            let queryObject = {
                redirectUrl:
                    this.$interfaces.logInModule.getRedirect() ||
                    this.$route.path,
            };
            LinkedInFlow.startAuthFlow(this.redirectPath, queryObject);
        },
    },
};
</script>

<style>
.linkedin-btn > img {
    margin: -4px 30px 4px 0 !important;
    width: 20px !important;
    height: 20px !important;
    filter: invert(100%);
}
</style>
